import { api } from '../../api/instance';

export const chatService = {
  list(page) { return api.get('v3/messages', { page: page || 1 }); },
  send(content, file) {
    if (file) {
      const fd = new FormData();
      fd.append('content', content || '');
      fd.append('image', file);
      return api.postForm('v3/messages', fd);
    }
    return api.post('v3/messages', { content });
  },
};



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/chatStore/service.js